const dateFormatter = {
    /**
     * Formats a date object to a yyyy-MM-dd string (ISO 8601).
     * @returns {string} - '2023-06-13'
     */
    yyyyMMdd: (date: Date) => {
        return date.toISOString().split('T')[0];
    },

    /**
     * Formats a date object to a dd-MM-yyyy string.
     * @returns {string} - '13-06-2023'
     */
    ddMMyyyy: (date: Date) => {
        return date.toLocaleDateString('en-GB').replace(/\//g, '-');
    },

    /**
     * Formats a date object to a user friendly readable string.
     * @returns {string} - '13. juni 2023'
     */
    userFriendly: (date: Date) => {
        //const long = { year: 'numeric', month: 'long', day: 'numeric' };
        //const long = { year: 'numeric', month: '2-digit', day: '2-digit' };
        const dateOptions: Intl.DateTimeFormatOptions = {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        };

        return date.toLocaleDateString('da-DK', dateOptions);
    }
};

// 120478-0668 => 12-04-78
const cpr2BirthDate = (cprString: string) => {
    if (cprString?.length !== 10) return '';
    return cprString
        .slice(0, 6)
        ?.match(/.{1,2}/g)
        ?.join('-');
};

export default dateFormatter;
export { cpr2BirthDate };
